import React from 'react';
import Banner from '../Banner/Banner';
import NavBar from '../NavBar/NavBar';

const HeaderPart = () => {
    return (
        <div>
            <Banner></Banner>
        </div>
    );
};

export default HeaderPart;